import { UpdateTopicOrderRequest } from '@models/marketing/topics/topics.model';
import { patchState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { catchError, EMPTY, pipe, switchMap, tap } from 'rxjs';
import { NewsArticlesService } from '../news-articles.service';
import { NewsArticlesStore } from '../news-articles.store';

export const getNewsArticlesTopicsOrderMethods = (injects: { store: NewsArticlesStore; newsArticlesService: NewsArticlesService }) => {
  const { store, newsArticlesService } = injects;

  const getTopicsOrder = rxMethod<void>(
    pipe(
      tap(() => patchState(store, { isTopicsOrderLoading: true })),
      switchMap(() =>
        newsArticlesService.getTopicsOrder().pipe(
          tap(topicsOrder => patchState(store, { topicsOrder, isTopicsOrderLoading: false })),
          catchError(() => {
            patchState(store, { isTopicsOrderLoading: false });
            return EMPTY;
          }),
        ),
      ),
    ),
  );

  const setTopicsOrder = rxMethod<UpdateTopicOrderRequest>(
    pipe(
      tap(() => patchState(store, { isSetTopicsOrderLoading: true })),
      switchMap(topicsOrder =>
        newsArticlesService.setTopicsOrder(topicsOrder).pipe(
          tap(topicsOrder => {
            patchState(store, { topicsOrder, isSetTopicsOrderLoading: false });
          }),
          catchError(() => {
            patchState(store, { isSetTopicsOrderLoading: false });
            return EMPTY;
          }),
        ),
      ),
    ),
  );

  return {
    getTopicsOrder,
    setTopicsOrder,
  };
};

export interface NewsArticleTopicsOrderStoreType {
  readonly getTopicsOrder: () => void;
  readonly setTopicsOrder: (topicsOrder: UpdateTopicOrderRequest) => void;
}
